<div class="container chart" *ngIf="pdfSidebar" [ngClass]="query?.orientation">

  <div class="logo hidden"><img src="../../../../assets/images/logo_header.svg" /></div>

  <div *ngIf="query?.sampleRequest == 2 && !query.noOverview" style="font-size:larger">Sample request<br><br></div>


  <!-- FILTER HEADER -->

  <div class="filter" *ngIf="query && !query?.noOverview">
    <div>
      <h5>{{ search.customeroverview.nameOverride || (now() | date : 'yyMMdd') }}&nbsp;&nbsp;Business overview</h5>
      <div style="position:relative">
        <table>
          <!-- <ng-container *ngTemplateOutlet="commonFilters"></ng-container> -->
          <tr><td>RSM</td><td>{{accountManagerNames || getUserName(query.manager) || 'All'}}</td></tr>
          <tr><td>Issuer</td><td>{{query.issuer ? getIssuer(query.issuer) : 'All'}}</td></tr>
          <tr><td>Country</td><td>{{query.country || 'All'}}</td></tr>
          <tr><td>Customers</td><td>{{query.customers?.length ? getTextFromArray(query.customers, data.businesses) : 'All'}}</td></tr>
          <tr><td>Bussiness units</td><td>{{query.businessUnits?.length ? getTextFromArray(query.businessUnits, data.businessUnits) : 'All'}}</td></tr>
          <tr><td>Issue date from</td><td>{{query.dateFrom ? (query.dateFrom | date : 'yyyy-MM-dd') : 'All'}}</td></tr>
          <tr><td>Issue date to</td><td>{{query.dateTo ? (query.dateTo | date : 'yyyy-MM-dd') : 'All'}}</td></tr>
          <tr><td>Trial code</td><td>{{query.trial?.trial || 'All'}}</td></tr>
          <!-- <tr><td>Finished product</td><td>{{query.finishedProduct?.calcName || 'All'}}</td></tr> -->
          <tr><td>Finished products</td><td style="white-space:pre-wrap">{{finishedProductNames}}</td></tr>
        </table>
      </div>
    </div>
  </div>

  <!-- REPORT CHARTS -->

  <ngx-doc-form-checkbox style="padding-top:5px;" class="fullwidth hidden" label="Show chart overview" [(value)]="showCharts"></ngx-doc-form-checkbox>

  <ngx-loading-spinner [loading]="loading"></ngx-loading-spinner>
  <div class="nodata hidden" *ngIf="pdfData == null">
    <span *ngIf="!loading">no data available</span>
  </div>

  <ng-container  *ngIf="pdfData != null && !loading && !query?.noOverview">

    <div  [ngStyle]="{ textAlign: 'center', display: showCharts ? 'block' : 'none' }">
      <div class="section-title">Turnover comparison (date selection)</div>
      <table style="margin: 0 auto">
        <tr><td>
          <table class="xls-table" style="margin: 0 auto;font-size:larger;">
            <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th><th>%</th></tr>
            <tr *ngFor="let y of pdfData.tables?.selection"> <!-- interval -->
              <td>{{y?.dateFrom}}</td>
              <td>{{y?.dateTo}}</td>
              <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
              <td style="text-align:right">{{(y?.data?.percent || 0) | number : '1.0-0'}} %</td></tr>
          </table>
        </td><td style="width:380px">
          <ngx-customer-chart [options]="pdfData.charts?.selectionChart" [size]="[300, 125]"></ngx-customer-chart>
        </td></tr>
      </table>

      <ng-container *ngIf="showChart('thisYearChart')">
        <div class="section-title">Turnover comparison (year)</div>
        <table style="margin: 0 auto">
          <tr><td>
            <table class="xls-table" style="margin: 0 auto;font-size:larger;">
              <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th><th>%</th></tr>
              <tr *ngFor="let y of pdfData.tables?.thisYear"> <!-- year -->
                <td>{{y?.dateFrom}}</td>
                <td>{{y?.dateTo}}</td>
                <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                <td style="text-align:right">{{(y?.data?.percent || 0) | number : '1.0-0'}} %</td></tr>
            </table>
          </td><td style="width:380px">
            <ngx-customer-chart [options]="pdfData.charts.thisYearChart"  [size]="[300, 125]"></ngx-customer-chart>
          </td></tr>
        </table>
      </ng-container>

      <div class="no-page-break" *ngIf="showChart('chartOverTime')">
        <div class="section-title">Invoices & Open Orders by Month</div>
        <ngx-customer-chart [options]="pdfData.charts.chartOverTime"></ngx-customer-chart>
      </div>
  
      <div class="no-page-break" *ngIf="showChart('issuerChart')">
        <div class="section-title">Turnover by Issuer</div>
        <ngx-customer-chart [options]="pdfData.charts.issuerChart"></ngx-customer-chart>
      </div>

      <div class="no-page-break" *ngIf="showChart('rsmChart')">
        <div class="section-title">Turnover by RSM</div>
        <ngx-customer-chart [options]="pdfData.charts.rsmChart"></ngx-customer-chart>
      </div>

      <div class="no-page-break" *ngIf="showChart('countryChart')">
        <div class="section-title">Turnover by Country</div>
        <ngx-customer-chart [options]="pdfData.charts.countryChart"></ngx-customer-chart>
      </div>

      <div class="no-page-break" *ngIf="showChart('customerChart')">
        <div class="section-title">Turnover by Customer</div>
        <ngx-customer-chart [options]="pdfData.charts.customerChart"></ngx-customer-chart>
      </div>

      <div class="no-page-break" *ngIf="showChart('businessUnitChart')">
        <div class="section-title">Turnover by Business Unit</div>
        <ngx-customer-chart [options]="pdfData.charts.businessUnitChart"></ngx-customer-chart>
      </div>

      <div class="no-page-break" *ngIf="showChart('baseProductChart')">
        <div class="section-title">Turnover by Base Product</div>
        <ngx-customer-chart [options]="pdfData.charts.baseProductChart" [size]="[700,500]"></ngx-customer-chart>
      </div>

      <div class="no-page-break" *ngIf="showChart('finishedProductChart')">
        <div class="section-title">Turnover by Finished Product</div>
        <ngx-customer-chart [options]="pdfData.charts.finishedProductChart" [size]="[700,600]"></ngx-customer-chart>
      </div>

    </div>

  </ng-container>
</div>

<!-- PDF REPORTS -->

<ng-container *ngIf="!search.customeroverview.sortByManager">
  <div *ngFor="let params of attachedReports" class="attached-reports">
    <!-- <pre>{{getParams(params)}}</pre> -->
    <ngx-reports-printer [search]="params" [pdfSidebar]="pdfSidebar" [printCount]="true" (done)="reportLoaded()"></ngx-reports-printer>     
  </div>
</ng-container>

<ng-container *ngIf="search.customeroverview.sortByManager && !secondRun">
  <div *ngFor="let params of attachedReports" class="attached-reports">
    <!-- <pre>{{getParams(params)}}</pre> -->
    <ngx-reports-printer [search]="params" [pdfSidebar]="pdfSidebar" [printCount]="true" [silent]="true" (done)="reportLoaded($event)"></ngx-reports-printer>     
  </div>
</ng-container>

<ng-container *ngIf="search.customeroverview.sortByManager" && secondRun>
  <div *ngFor="let manager of accountManagers">
    <div *ngFor="let report of manager.reports; first as isFirst" class="attached-reports">
      <ngx-reports-printer [search]="report" [pdfSidebar]="pdfSidebar" [printCount]="true" (done)="reportLoaded()" [extraTitle]="isFirst && manager.name"></ngx-reports-printer>     
    </div>
  </div>
</ng-container>

<div class="doc-footer hidden">
  <button class="btn btn-default btn-lg" (click)="onClosePreview()">Back</button>
  <button class="btn btn-info btn-lg" (click)="onDownloadPdf()">Download PDF</button>
</div>

